// environment.js
//versions 20250922 11:24
const appId = "hr-recruitment/questionnaire/erp/bosum-ticket/bosum-mgmt-mp";
let env = "production";


const config = {
    dev: {
        baseURL: "https://erptest.bosum.com/erp/message",
    },
    development: {
        baseURL: "https://erptest.bosum.com/erp/message",
    },
    test: {
        baseURL: "https://erptest.bosum.com/erp/message",
    },
    release: {
        baseURL: "https://erptest.bosum.com/erp/message",
    },
    production: {
        baseURL: "https://erp.bosum.com/erp/message",
    },
};

config[env] = {
        baseURL: process.env.VERIFY_API
    }
console.log("接口地址:", config[env]);

export default {
    env,
    ...config[env],
    appId
};



// WEBPACK FOOTER //
// ./src/utils/verify-sdk/environment.js